(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topstitch-global-overrides"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var SEL = [
      '.ts-reveal',
      '.ts-page-hero__eyebrow',
      '.ts-page-hero__title',
      '.ts-page-hero__text',
      '.ts-page-hero__button',
      '.ts-page-hero__note',
      '.ts-page-hero__links',
      '.ts-home-hero-refined__eyebrow',
      '.ts-home-hero-refined__title',
      '.ts-home-hero-refined__copy',
      '.ts-home-hero-refined__actions',
      '.ts-home-trust__eyebrow',
      '.ts-home-feature__eyebrow',
      '.ts-home-pipeline__eyebrow',
      '.ts-home-services__intro',
      '.ts-service-card',
      '.ts-product-card',
      '.ts-service-rich__overview-media',
      '.ts-service-rich__overview-copy',
      '.ts-service-rich__kicker',
      '.ts-service-rich__step',
      '.ts-service-cta__primary',
      '.ts-service-cta__contact',
      '.ts-services-catalog__card',
      '.ts-services-catalog__detail',
      '.ts-cta-banner',
      '.ts-pipeline-step',
      '.topstitch-service-nav__item',
      '.ts-editorial__card',
      '.ts-showcase__intro',
      '.ts-showcase__panel'
    ].join(',');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ts-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    function observe() {
      document.querySelectorAll(SEL).forEach(function(el) {
        if (!el.classList.contains('ts-visible')) {
          observer.observe(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(observe, 100);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
